import apiClient from "../../client/apiClient"
import { UserState } from "../../core/data/redux/slice/user"

const AUTH_ENDPOINT = {
  LOGIN: "/auth/login",
  FETCH_PROFILE: "/auth/profile",
  LOGOUT: "/auth/logout",
}

const login = async (email: string, password: string): Promise<UserState> => {
  const response = await apiClient({
    data: { email, password },
    url: AUTH_ENDPOINT.LOGIN,
  })

  return response.data
}

const fetchProfile = async (): Promise<any> => {
  const response = await apiClient({
    url: AUTH_ENDPOINT.FETCH_PROFILE,
    method: "GET",
  })

  return response.data
}

const logout = async (): Promise<any> => {
  const response = await apiClient({
    url: AUTH_ENDPOINT.LOGOUT,
  })

  return response.data
}

export { login, fetchProfile, logout }
